export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('app:chunkError', () => {
    console.log('Chunk error detected, reloading page...');
    window.location.reload()
  });

  nuxtApp.hook('app:error', error => {
    if (error.message?.includes('Loading chunk')) {
      window.location.reload()
    }
  });
});
